import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentFail() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-md p-10 max-w-lg w-full text-center">
        <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center text-3xl bg-red-100 text-red-600">
          !
        </div>
        <h1 className="text-2xl font-bold mb-2">Оплата не прошла</h1>
        <p className="text-gray-600 mb-6">
          Платёж не был завершён. Попробуйте снова или выберите другой способ оплаты.
        </p>
        <Link
          to="/billing"
          className="inline-block px-6 py-3 rounded-xl bg-blue-600 text-white font-medium hover:bg-blue-700 transition shadow-md"
        >
          Вернуться в биллинг
        </Link>
        <p className="text-gray-500 text-xs mt-6">
          Вопросы? <a href="mailto:support@mailora.ru" className="text-blue-600">support@mailora.ru</a>
        </p>
      </div>
    </div>
  );
}